/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import * as reactQuery from "@tanstack/react-query";
import {
  useRoadroamerApiContext,
  RoadroamerApiContext,
} from "./roadroamerApiContext";
import type * as Fetcher from "./roadroamerApiFetcher";
import { roadroamerApiFetch } from "./roadroamerApiFetcher";
import type * as Schemas from "./roadroamerApiSchemas";

export type AppControllerGetHealthError = Fetcher.ErrorWrapper<undefined>;

export type AppControllerGetHealthVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchAppControllerGetHealth = (
  variables: AppControllerGetHealthVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    string,
    AppControllerGetHealthError,
    undefined,
    {},
    {},
    {}
  >({ url: "/health", method: "get", ...variables, signal });

export const useAppControllerGetHealth = <TData = string>(
  variables: AppControllerGetHealthVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, AppControllerGetHealthError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<string, AppControllerGetHealthError, TData>({
    queryKey: queryKeyFn({
      path: "/health",
      operationId: "appControllerGetHealth",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAppControllerGetHealth({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type UniversalLinkControllerGetAndroidAssetLinksError =
  Fetcher.ErrorWrapper<undefined>;

export type UniversalLinkControllerGetAndroidAssetLinksVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUniversalLinkControllerGetAndroidAssetLinks = (
  variables: UniversalLinkControllerGetAndroidAssetLinksVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UniversalLinkControllerGetAndroidAssetLinksError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/.well-known/assetlinks.json",
    method: "get",
    ...variables,
    signal,
  });

export const useUniversalLinkControllerGetAndroidAssetLinks = <
  TData = undefined
>(
  variables: UniversalLinkControllerGetAndroidAssetLinksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      UniversalLinkControllerGetAndroidAssetLinksError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    undefined,
    UniversalLinkControllerGetAndroidAssetLinksError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/.well-known/assetlinks.json",
      operationId: "universalLinkControllerGetAndroidAssetLinks",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUniversalLinkControllerGetAndroidAssetLinks(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type UniversalLinkControllerGetAppleAppSiteAssociationError =
  Fetcher.ErrorWrapper<undefined>;

export type UniversalLinkControllerGetAppleAppSiteAssociationVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUniversalLinkControllerGetAppleAppSiteAssociation = (
  variables: UniversalLinkControllerGetAppleAppSiteAssociationVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UniversalLinkControllerGetAppleAppSiteAssociationError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/.well-known/apple-app-site-association",
    method: "get",
    ...variables,
    signal,
  });

export const useUniversalLinkControllerGetAppleAppSiteAssociation = <
  TData = undefined
>(
  variables: UniversalLinkControllerGetAppleAppSiteAssociationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      UniversalLinkControllerGetAppleAppSiteAssociationError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    undefined,
    UniversalLinkControllerGetAppleAppSiteAssociationError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/.well-known/apple-app-site-association",
      operationId: "universalLinkControllerGetAppleAppSiteAssociation",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUniversalLinkControllerGetAppleAppSiteAssociation(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type UniversalLinkControllerHandlePark4NightIosRedirectError =
  Fetcher.ErrorWrapper<undefined>;

export type UniversalLinkControllerHandlePark4NightIosRedirectVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUniversalLinkControllerHandlePark4NightIosRedirect = (
  variables: UniversalLinkControllerHandlePark4NightIosRedirectVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UniversalLinkControllerHandlePark4NightIosRedirectError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/partner-redirect/park4night/ios",
    method: "get",
    ...variables,
    signal,
  });

export const useUniversalLinkControllerHandlePark4NightIosRedirect = <
  TData = undefined
>(
  variables: UniversalLinkControllerHandlePark4NightIosRedirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      UniversalLinkControllerHandlePark4NightIosRedirectError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    undefined,
    UniversalLinkControllerHandlePark4NightIosRedirectError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/partner-redirect/park4night/ios",
      operationId: "universalLinkControllerHandlePark4NightIosRedirect",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUniversalLinkControllerHandlePark4NightIosRedirect(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type UniversalLinkControllerHandlePark4NightAndroidRedirectError =
  Fetcher.ErrorWrapper<undefined>;

export type UniversalLinkControllerHandlePark4NightAndroidRedirectVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUniversalLinkControllerHandlePark4NightAndroidRedirect = (
  variables: UniversalLinkControllerHandlePark4NightAndroidRedirectVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UniversalLinkControllerHandlePark4NightAndroidRedirectError,
    undefined,
    {},
    {},
    {}
  >({
    url: "/partner-redirect/park4night/android",
    method: "get",
    ...variables,
    signal,
  });

export const useUniversalLinkControllerHandlePark4NightAndroidRedirect = <
  TData = undefined
>(
  variables: UniversalLinkControllerHandlePark4NightAndroidRedirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      UniversalLinkControllerHandlePark4NightAndroidRedirectError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    undefined,
    UniversalLinkControllerHandlePark4NightAndroidRedirectError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/partner-redirect/park4night/android",
      operationId: "universalLinkControllerHandlePark4NightAndroidRedirect",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUniversalLinkControllerHandlePark4NightAndroidRedirect(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type UniversalLinkControllerHandleRedirectError =
  Fetcher.ErrorWrapper<undefined>;

export type UniversalLinkControllerHandleRedirectVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUniversalLinkControllerHandleRedirect = (
  variables: UniversalLinkControllerHandleRedirectVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UniversalLinkControllerHandleRedirectError,
    undefined,
    {},
    {},
    {}
  >({ url: "/redirect/*", method: "get", ...variables, signal });

export const useUniversalLinkControllerHandleRedirect = <TData = undefined>(
  variables: UniversalLinkControllerHandleRedirectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      UniversalLinkControllerHandleRedirectError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    undefined,
    UniversalLinkControllerHandleRedirectError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/redirect/*",
      operationId: "universalLinkControllerHandleRedirect",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUniversalLinkControllerHandleRedirect(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type DirectionControllerGetDirectionsPathParams = {
  origin: string;
  destination: string;
};

export type DirectionControllerGetDirectionsQueryParams = {
  vehicleType: string;
  length?: number;
  width?: number;
  height?: number;
  router?: string;
  avoid?: string;
};

export type DirectionControllerGetDirectionsError =
  Fetcher.ErrorWrapper<undefined>;

export type DirectionControllerGetDirectionsVariables = {
  pathParams: DirectionControllerGetDirectionsPathParams;
  queryParams: DirectionControllerGetDirectionsQueryParams;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchDirectionControllerGetDirections = (
  variables: DirectionControllerGetDirectionsVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.GetDirectionsResponse,
    DirectionControllerGetDirectionsError,
    undefined,
    {},
    DirectionControllerGetDirectionsQueryParams,
    DirectionControllerGetDirectionsPathParams
  >({
    url: "/directions/{origin}/{destination}",
    method: "get",
    ...variables,
    signal,
  });

export const useDirectionControllerGetDirections = <
  TData = Schemas.GetDirectionsResponse
>(
  variables: DirectionControllerGetDirectionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetDirectionsResponse,
      DirectionControllerGetDirectionsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetDirectionsResponse,
    DirectionControllerGetDirectionsError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/directions/{origin}/{destination}",
      operationId: "directionControllerGetDirections",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchDirectionControllerGetDirections(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type DirectionControllerGetDirectionsV2Error =
  Fetcher.ErrorWrapper<undefined>;

export type DirectionControllerGetDirectionsV2Variables = {
  body: Schemas.PostDirectionV2Body;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchDirectionControllerGetDirectionsV2 = (
  variables: DirectionControllerGetDirectionsV2Variables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.PostDirectionV2Response,
    DirectionControllerGetDirectionsV2Error,
    Schemas.PostDirectionV2Body,
    {},
    {},
    {}
  >({ url: "/directions/v2", method: "post", ...variables, signal });

export const useDirectionControllerGetDirectionsV2 = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PostDirectionV2Response,
      DirectionControllerGetDirectionsV2Error,
      DirectionControllerGetDirectionsV2Variables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    Schemas.PostDirectionV2Response,
    DirectionControllerGetDirectionsV2Error,
    DirectionControllerGetDirectionsV2Variables
  >({
    mutationFn: (variables: DirectionControllerGetDirectionsV2Variables) =>
      fetchDirectionControllerGetDirectionsV2({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type UserControllerGetActiveUserError = Fetcher.ErrorWrapper<undefined>;

export type UserControllerGetActiveUserVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchUserControllerGetActiveUser = (
  variables: UserControllerGetActiveUserVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.UsersMeResponse,
    UserControllerGetActiveUserError,
    undefined,
    {},
    {},
    {}
  >({ url: "/users/me", method: "get", ...variables, signal });

export const useUserControllerGetActiveUser = <TData = Schemas.UsersMeResponse>(
  variables: UserControllerGetActiveUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UsersMeResponse,
      UserControllerGetActiveUserError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    Schemas.UsersMeResponse,
    UserControllerGetActiveUserError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/users/me",
      operationId: "userControllerGetActiveUser",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchUserControllerGetActiveUser(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type UserControllerUpdateUserError = Fetcher.ErrorWrapper<undefined>;

export type UserControllerUpdateUserVariables = {
  body: Schemas.UserMeUpdateBody;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchUserControllerUpdateUser = (
  variables: UserControllerUpdateUserVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    UserControllerUpdateUserError,
    Schemas.UserMeUpdateBody,
    {},
    {},
    {}
  >({ url: "/users/me", method: "post", ...variables, signal });

export const useUserControllerUpdateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UserControllerUpdateUserError,
      UserControllerUpdateUserVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    undefined,
    UserControllerUpdateUserError,
    UserControllerUpdateUserVariables
  >({
    mutationFn: (variables: UserControllerUpdateUserVariables) =>
      fetchUserControllerUpdateUser({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type KindeWebhookControllerWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type KindeWebhookControllerWebhookVariables = {
  body?: Schemas.Buffer;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchKindeWebhookControllerWebhook = (
  variables: KindeWebhookControllerWebhookVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    undefined,
    KindeWebhookControllerWebhookError,
    Schemas.Buffer,
    {},
    {},
    {}
  >({ url: "/kinde/webhook", method: "post", ...variables, signal });

export const useKindeWebhookControllerWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      KindeWebhookControllerWebhookError,
      KindeWebhookControllerWebhookVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    undefined,
    KindeWebhookControllerWebhookError,
    KindeWebhookControllerWebhookVariables
  >({
    mutationFn: (variables: KindeWebhookControllerWebhookVariables) =>
      fetchKindeWebhookControllerWebhook({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type PaymentControllerCreateCheckoutSessionError =
  Fetcher.ErrorWrapper<undefined>;

export type PaymentControllerCreateCheckoutSessionVariables = {
  body: Schemas.CreateCheckoutSessionBody;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchPaymentControllerCreateCheckoutSession = (
  variables: PaymentControllerCreateCheckoutSessionVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.CreateCheckoutSessionResponse,
    PaymentControllerCreateCheckoutSessionError,
    Schemas.CreateCheckoutSessionBody,
    {},
    {},
    {}
  >({
    url: "/payment/create-checkout-session",
    method: "post",
    ...variables,
    signal,
  });

export const usePaymentControllerCreateCheckoutSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.CreateCheckoutSessionResponse,
      PaymentControllerCreateCheckoutSessionError,
      PaymentControllerCreateCheckoutSessionVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    Schemas.CreateCheckoutSessionResponse,
    PaymentControllerCreateCheckoutSessionError,
    PaymentControllerCreateCheckoutSessionVariables
  >({
    mutationFn: (variables: PaymentControllerCreateCheckoutSessionVariables) =>
      fetchPaymentControllerCreateCheckoutSession({
        ...fetcherOptions,
        ...variables,
      }),
    ...options,
  });
};

export type CatalogControllerCatalogError = Fetcher.ErrorWrapper<undefined>;

export type CatalogControllerCatalogVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchCatalogControllerCatalog = (
  variables: CatalogControllerCatalogVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.CatalogResponse,
    CatalogControllerCatalogError,
    undefined,
    {},
    {},
    {}
  >({ url: "/catalog", method: "get", ...variables, signal });

export const useCatalogControllerCatalog = <TData = Schemas.CatalogResponse>(
  variables: CatalogControllerCatalogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.CatalogResponse,
      CatalogControllerCatalogError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    Schemas.CatalogResponse,
    CatalogControllerCatalogError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/catalog",
      operationId: "catalogControllerCatalog",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchCatalogControllerCatalog(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type StripeWebhookControllerWebhookHeaders = {
  ["stripe-signature"]: string;
};

export type StripeWebhookControllerWebhookError =
  Fetcher.ErrorWrapper<undefined>;

export type StripeWebhookControllerWebhookVariables = {
  headers: StripeWebhookControllerWebhookHeaders;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchStripeWebhookControllerWebhook = (
  variables: StripeWebhookControllerWebhookVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Record<string, any>,
    StripeWebhookControllerWebhookError,
    undefined,
    StripeWebhookControllerWebhookHeaders,
    {},
    {}
  >({ url: "/stripe/webhook", method: "post", ...variables, signal });

export const useStripeWebhookControllerWebhook = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Record<string, any>,
      StripeWebhookControllerWebhookError,
      StripeWebhookControllerWebhookVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    Record<string, any>,
    StripeWebhookControllerWebhookError,
    StripeWebhookControllerWebhookVariables
  >({
    mutationFn: (variables: StripeWebhookControllerWebhookVariables) =>
      fetchStripeWebhookControllerWebhook({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type VehicleControllerPostVehicleError = Fetcher.ErrorWrapper<undefined>;

export type VehicleControllerPostVehicleVariables = {
  body: Schemas.PostVehicleBody;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchVehicleControllerPostVehicle = (
  variables: VehicleControllerPostVehicleVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.PostVehicleResponse,
    VehicleControllerPostVehicleError,
    Schemas.PostVehicleBody,
    {},
    {},
    {}
  >({ url: "/vehicle", method: "post", ...variables, signal });

export const useVehicleControllerPostVehicle = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PostVehicleResponse,
      VehicleControllerPostVehicleError,
      VehicleControllerPostVehicleVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    Schemas.PostVehicleResponse,
    VehicleControllerPostVehicleError,
    VehicleControllerPostVehicleVariables
  >({
    mutationFn: (variables: VehicleControllerPostVehicleVariables) =>
      fetchVehicleControllerPostVehicle({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type VehicleControllerGetVehicleError = Fetcher.ErrorWrapper<undefined>;

export type VehicleControllerGetVehicleVariables =
  RoadroamerApiContext["fetcherOptions"];

export const fetchVehicleControllerGetVehicle = (
  variables: VehicleControllerGetVehicleVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.GetVehicleResponse,
    VehicleControllerGetVehicleError,
    undefined,
    {},
    {},
    {}
  >({ url: "/vehicle", method: "get", ...variables, signal });

export const useVehicleControllerGetVehicle = <
  TData = Schemas.GetVehicleResponse
>(
  variables: VehicleControllerGetVehicleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetVehicleResponse,
      VehicleControllerGetVehicleError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetVehicleResponse,
    VehicleControllerGetVehicleError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/vehicle",
      operationId: "vehicleControllerGetVehicle",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchVehicleControllerGetVehicle(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type VehicleControllerPatchVehiclePathParams = {
  id: string;
};

export type VehicleControllerPatchVehicleError =
  Fetcher.ErrorWrapper<undefined>;

export type VehicleControllerPatchVehicleVariables = {
  body?: Schemas.PatchVehicleBody;
  pathParams: VehicleControllerPatchVehiclePathParams;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchVehicleControllerPatchVehicle = (
  variables: VehicleControllerPatchVehicleVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.PatchVehicleResponse,
    VehicleControllerPatchVehicleError,
    Schemas.PatchVehicleBody,
    {},
    {},
    VehicleControllerPatchVehiclePathParams
  >({ url: "/vehicle/{id}", method: "patch", ...variables, signal });

export const useVehicleControllerPatchVehicle = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.PatchVehicleResponse,
      VehicleControllerPatchVehicleError,
      VehicleControllerPatchVehicleVariables
    >,
    "mutationFn"
  >
) => {
  const { fetcherOptions } = useRoadroamerApiContext();
  return reactQuery.useMutation<
    Schemas.PatchVehicleResponse,
    VehicleControllerPatchVehicleError,
    VehicleControllerPatchVehicleVariables
  >({
    mutationFn: (variables: VehicleControllerPatchVehicleVariables) =>
      fetchVehicleControllerPatchVehicle({ ...fetcherOptions, ...variables }),
    ...options,
  });
};

export type AppVersionControllerHandleAppVersionHeaders = {
  os?: string;
};

export type AppVersionControllerHandleAppVersionError =
  Fetcher.ErrorWrapper<undefined>;

export type AppVersionControllerHandleAppVersionVariables = {
  headers?: AppVersionControllerHandleAppVersionHeaders;
} & RoadroamerApiContext["fetcherOptions"];

export const fetchAppVersionControllerHandleAppVersion = (
  variables: AppVersionControllerHandleAppVersionVariables,
  signal?: AbortSignal
) =>
  roadroamerApiFetch<
    Schemas.GetAppVersionResponse,
    AppVersionControllerHandleAppVersionError,
    undefined,
    AppVersionControllerHandleAppVersionHeaders,
    {},
    {}
  >({ url: "/app-version", method: "get", ...variables, signal });

export const useAppVersionControllerHandleAppVersion = <
  TData = Schemas.GetAppVersionResponse
>(
  variables: AppVersionControllerHandleAppVersionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.GetAppVersionResponse,
      AppVersionControllerHandleAppVersionError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useRoadroamerApiContext(options);
  return reactQuery.useQuery<
    Schemas.GetAppVersionResponse,
    AppVersionControllerHandleAppVersionError,
    TData
  >({
    queryKey: queryKeyFn({
      path: "/app-version",
      operationId: "appVersionControllerHandleAppVersion",
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchAppVersionControllerHandleAppVersion(
        { ...fetcherOptions, ...variables },
        signal
      ),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: "/health";
      operationId: "appControllerGetHealth";
      variables: AppControllerGetHealthVariables;
    }
  | {
      path: "/.well-known/assetlinks.json";
      operationId: "universalLinkControllerGetAndroidAssetLinks";
      variables: UniversalLinkControllerGetAndroidAssetLinksVariables;
    }
  | {
      path: "/.well-known/apple-app-site-association";
      operationId: "universalLinkControllerGetAppleAppSiteAssociation";
      variables: UniversalLinkControllerGetAppleAppSiteAssociationVariables;
    }
  | {
      path: "/partner-redirect/park4night/ios";
      operationId: "universalLinkControllerHandlePark4NightIosRedirect";
      variables: UniversalLinkControllerHandlePark4NightIosRedirectVariables;
    }
  | {
      path: "/partner-redirect/park4night/android";
      operationId: "universalLinkControllerHandlePark4NightAndroidRedirect";
      variables: UniversalLinkControllerHandlePark4NightAndroidRedirectVariables;
    }
  | {
      path: "/redirect/*";
      operationId: "universalLinkControllerHandleRedirect";
      variables: UniversalLinkControllerHandleRedirectVariables;
    }
  | {
      path: "/directions/{origin}/{destination}";
      operationId: "directionControllerGetDirections";
      variables: DirectionControllerGetDirectionsVariables;
    }
  | {
      path: "/users/me";
      operationId: "userControllerGetActiveUser";
      variables: UserControllerGetActiveUserVariables;
    }
  | {
      path: "/catalog";
      operationId: "catalogControllerCatalog";
      variables: CatalogControllerCatalogVariables;
    }
  | {
      path: "/vehicle";
      operationId: "vehicleControllerGetVehicle";
      variables: VehicleControllerGetVehicleVariables;
    }
  | {
      path: "/app-version";
      operationId: "appVersionControllerHandleAppVersion";
      variables: AppVersionControllerHandleAppVersionVariables;
    };
